import {makeStyles} from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
    container: {
        padding: "15px",
        backgroundColor: theme.palette.common.white,
    },
    info_container: {
        display: "flex",
    },
    item_row: {
        paddingLeft: '20px'
    }
}));

export {useStyles};
